import type { I18nPluralForms } from "cruzo";

export function i18nText(message: string | I18nPluralForms | undefined): string {
  if (message == null) {
    return "";
  }
  if (typeof message === "string") {
    return message;
  }
  return message.other ?? "";
}

export function i18nFormat(
  message: string | I18nPluralForms | undefined,
  vars: Record<string, string | number>,
): string {
  let text = i18nText(message);
  for (const [key, value] of Object.entries(vars)) {
    text = text.replace(new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, "g"), String(value));
  }
  return text;
}
